import { useState } from 'react';
import Song from './components/Song';

function App() {
  const [currentPlaying, setCurrentPlaying] = useState(null);

  const handleSongPlay = (songName) => {
    setCurrentPlaying(prev => prev === songName ? null : songName);
  };

  const handleStop = () => {
    setCurrentPlaying(null);
  };

  return (
    <div 
      className="App min-h-screen w-screen flex flex-col items-center justify-start sm:justify-center gap-5 sm:gap-8 bg-black mt-5 sm:mt-0"
      style={{ touchAction: 'none' }} // Bloquea gestos no deseados
    >
      <div className="grid grid-cols-2 md:grid-cols-3 gap-5 sm:gap-10 justify-center mx-auto">

        <Song 
          song="nana" 
          isPlaying={currentPlaying === "nana"} 
          onPlay={handleSongPlay} 
        />
        <Song 
          song="david" 
          isPlaying={currentPlaying === "david"} 
          onPlay={handleSongPlay} 
        />
        <Song 
          song="ya ya" 
          isPlaying={currentPlaying === "ya ya"} 
          onPlay={handleSongPlay} 
        />
        <Song 
          song="lazaro" 
          isPlaying={currentPlaying === "lazaro"} 
          onPlay={handleSongPlay} 
        />
        <Song 
          song="jonas" 
          isPlaying={currentPlaying === "jonas"} 
          onPlay={handleSongPlay} 
        />
        <Song 
          song="tu gozo" 
          isPlaying={currentPlaying === "tu gozo"} 
          onPlay={handleSongPlay} 
        />
      </div>

      {/* Botón de STOP (círculo perfecto) */}
      <button
        onClick={handleStop}
        className="mt-0 text-white text-2xl rounded-full border-2 border-white w-12 h-12 flex items-center justify-center active:bg-gray-800"
      >
        <i className="fa-solid fa-stop"></i>
      </button>
    </div>
  );
}

export default App;